// Renders saved template / report HTML OUTSIDE the editor (preview panes,
// read-only views).
//
// Why this exists: the editor's own table and heading styling lives in
// ClinicalEditor.scss, scoped under `.clinical-editor`. Dropping the same HTML
// into a plain <div> therefore loses every border, padding and heading size —
// a table renders as unaligned bare text. Any new place that displays report
// content should use this component so it looks identical everywhere.
//
// Kept deliberately close to SHEET_CSS in src/utils/reportSheet.js: what
// the radiology user previews is what prints.
import React from "react";

const DOC_CSS = `
.rad-doc { font-size: 13px; line-height: 1.6; color: #0d233f; word-break: break-word; }
.rad-doc > :first-child { margin-top: 0; }
.rad-doc h1 { font-size: 18px; font-weight: 700; margin: 18px 0 8px; }
.rad-doc h2 { font-size: 15px; font-weight: 700; margin: 16px 0 7px; }
.rad-doc h3 { font-size: 13px; font-weight: 700; margin: 14px 0 6px;
              text-transform: uppercase; letter-spacing: 0.04em; }
.rad-doc p { margin: 0 0 8px; }
.rad-doc ul, .rad-doc ol { margin: 0 0 8px; padding-left: 22px; }
.rad-doc li { margin-bottom: 3px; }
.rad-doc li > p { margin: 0; }
.rad-doc hr { border: none; border-top: 1px solid #d1d5db; margin: 14px 0; }
.rad-doc blockquote { margin: 0 0 8px; padding-left: 12px; border-left: 3px solid #d1d5db; color: #4b5563; }
.rad-doc mark { background: #fef08a; padding: 0 2px; }

/* Tables — the editor writes plain <table>/<th>/<td>, sometimes with a
   <colgroup> carrying the author's column widths. Respect those when present. */
.rad-doc table { border-collapse: collapse; width: 100%; margin: 12px 0; }
.rad-doc th, .rad-doc td {
  border: 1px solid #d1d5db; padding: 7px 10px;
  text-align: left; vertical-align: top; font-size: 12px;
}
.rad-doc th { background: #f3f4f6; font-weight: 700; }
.rad-doc th > p, .rad-doc td > p { margin: 0; }

/* Long documents inside a fixed-height pane shouldn't push the table off-screen. */
.rad-doc-scroll { overflow-x: auto; }
`;

export default function ReportContent({ html, style, emptyText = "Empty." }) {
  return (
    <>
      <style>{DOC_CSS}</style>
      <div
        className="rad-doc rad-doc-scroll"
        style={style}
        // Authored in-house by admin/radiology users through the editor —
        // never patient- or public-supplied input.
        dangerouslySetInnerHTML={{ __html: html || `<p>${emptyText}</p>` }}
      />
    </>
  );
}
